import { fieldMap2, typeMap2, unitMap, dataTypeMap } from "@/constants/dataMap";
import towerJson from "@/Components/Diagram/elementsData/tower.json";
import heatExchanger from "@/Components/Diagram/elementsData/heatExchanger.json";
import MultiStreamExchanger from "@/Components/Diagram/elementsData/MultiStreamExchanger.json";
import {setStreamsType} from "./setStreamsType";

export const buildTaskInput = (jsonData:any,selectedElements:string[],state:any,cal:string,taskName:string,type:string,isCopy?:boolean) => 
{
    // console.log('jsonData',jsonData);
    const flowId = state.curFlow["id"];
    const flowName = state.curFlow["name"];
    const flowDes = state.curFlow["description"] || "";
    const globlePhysicalMethod = state.globle_physical_method;

    // console.log('stateeeeeeee',state);

    let elements = [];
    let streams = [];
    let desElements = [];
    let desStreams = [];
    let inputStreamsMap = {};
    let outputStreamsMap = {};
    let groupsMap = {};

    // 处理 group 数据
    let groupDatas = jsonData.nodeDataArray.filter((item: any) => item.isGroup);
    for (let i = 0; i < groupDatas.length; i++) {
        let groupKey = groupDatas[i].key;
        let groupName = groupDatas[i].keywords;
        groupsMap[groupKey] = groupName;
    }

    // 处理 streams 数据
    for (let i = 0; i < jsonData.linkDataArray.length; i++) {
        let linkData = jsonData.linkDataArray[i];
        if (linkData.linkName && linkData.linkName !== "") {
        let streamsNmae = linkData.linkName;
        let streamsSection = "";
        let streamsType = "";
        let streamAttribute = "";
        let streamsFrom = linkData.from;
        let streamsTo = linkData.to;
        let streamsFromPort = linkData.fromPort;
        let streamsToPort = linkData.toPort;

        let streamsParams = {};
        let desStreamsParams = {};
        if (linkData.ParamValues) {
            for (let key in linkData.ParamValues) {
            let field = key;
            if (linkData.ParamValues[key].engName && linkData.ParamValues[key].engName !== "") {
                field = linkData.ParamValues[key].engName;
            } else {
                if (fieldMap2[key] !== undefined) {
                field = fieldMap2[key];
                }
            }

            if (field === "type") {
                streamsType = linkData.ParamValues[key].value;
                continue;
            }
            if (field === "streamAttribute") {
                streamAttribute = linkData.ParamValues[key].value;
                // continue;
            }

            if (linkData.ParamValues[key].unit) {
                let value = linkData.ParamValues[key].value;
                let desValue = linkData.ParamValues[key].desValue;
                let engName = linkData.ParamValues[key].engName;
                if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                if (value !== "") {
                    value = Number(value);
                    if (Number.isNaN(value)) value = null;
                } else {
                    value = null;
                }

                if (desValue !== "") {
                    desValue = Number(desValue);
                    if (Number.isNaN(desValue)) desValue = null;
                } else {
                    desValue = null;
                }
                } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                if (value === "") value = null;
                if (desValue === "") desValue = null;
                }

                streamsParams[field] = value;
                desStreamsParams[field] = desValue;

                if (linkData.ParamValues[key].unitField !== undefined) {
                if (linkData.ParamValues[key].unitField !== null) {
                    if (linkData.ParamValues[key].unitField === "") {
                    streamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                    desStreamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                    } else {
                    streamsParams[linkData.ParamValues[key].unitField] =
                        linkData.ParamValues[key].unit;
                    desStreamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                    }
                }
                }
            } else {
                let value = linkData.ParamValues[key].value;
                let desValue = linkData.ParamValues[key].desValue;
                let engName = linkData.ParamValues[key].engName;
                if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                if (value !== "") {
                    value = Number(value);
                    if (Number.isNaN(value)) value = null;
                } else {
                    value = null;
                }

                if (desValue !== "") {
                    desValue = Number(desValue);
                    if (Number.isNaN(desValue)) desValue = null;
                } else {
                    desValue = null;
                }
                } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                if (value === "") value = null;
                if (desValue === "") desValue = null;
                }

                streamsParams[field] = value;
                desStreamsParams[field] = desValue;
            }
            }
        }

        let materials = [];
        let desMaterials = [];
        if (linkData.materials) {
            for (let key in linkData.materials) {
            let molarFrac = linkData.materials[key].molar_frac;
            if (molarFrac !== "") {
                molarFrac = Number(molarFrac);
                if (Number.isNaN(molarFrac)) molarFrac = null;
            } else {
                molarFrac = null;
            }
            let material = {
                cas: linkData.materials[key].cas,
                molar_frac: molarFrac,
                name: linkData.materials[key].name,
            };
            materials.push(material);

            let desValue = linkData.materials[key].desValue;
            if (desValue !== "") {
                desValue = Number(desValue);
                if (Number.isNaN(desValue)) desValue = null;
            } else {
                desValue = null;
            }
            let desMaterial = {
                cas: linkData.materials[key].cas,
                molar_frac: desValue,
                name: linkData.materials[key].name,
            };
            desMaterials.push(desMaterial);
            }
        }

        let inputStreamMap = {
            name: streamsNmae,
            rule: streamsToPort,
            streamAttribute: streamAttribute,
        };
        if (!inputStreamsMap[streamsTo]) inputStreamsMap[streamsTo] = [];
        inputStreamsMap[streamsTo].push(inputStreamMap);

        let outputStreamMap = {
            name: streamsNmae,
            rule: streamsFromPort,
            streamAttribute: streamAttribute,
        };
        if (!outputStreamsMap[streamsFrom]) outputStreamsMap[streamsFrom] = [];
        outputStreamsMap[streamsFrom].push(outputStreamMap);

        if (
            jsonData.nodeDataArray.filter((item: any) => !item.isGroup && item.key === streamsFrom)
            .length > 0
        ) {
            let streamsFromElement = jsonData.nodeDataArray.filter(
            (item: any) => !item.isGroup && item.key === streamsFrom,
            )[0];
            if (streamsFromElement && streamsFromElement.group) {
            streamsSection = groupsMap[streamsFromElement.group];
            }
        }
        if (streamsSection === "") {
            if (
            jsonData.nodeDataArray.filter((item: any) => !item.isGroup && item.key === streamsTo)
                .length > 0
            ) {
            let streamsToElement = jsonData.nodeDataArray.filter(
                (item: any) => !item.isGroup && item.key === streamsTo,
            )[0];
            if (streamsToElement && streamsToElement.group) {
                streamsSection = groupsMap[streamsToElement.group];
            }
            }
        }

        let toElementName =
            jsonData.nodeDataArray.find((item:any) => !item.isGroup && item.key === streamsTo)?.nodeName ??
            "";
        let fromElementName =
            jsonData.nodeDataArray.find((item:any) => !item.isGroup && item.key === streamsFrom)
            ?.nodeName ?? "";

        if (selectedElements.includes(toElementName) || selectedElements.includes(fromElementName)) {
            let stream = {
            name: streamsNmae,
            section: streamsSection,
            type: streamsType,
            params: streamsParams,
            materials: materials,
            // isRun:false,
            };
            streams.push(stream);

            let desStream = {
            name: streamsNmae,
            section: streamsSection,
            type: streamsType,
            params: desStreamsParams,
            materials: desMaterials,
            // isRun:false,
            };
            desStreams.push(desStream);
        }
        }
    }
    
    // 处理 elements 数据
    for (let i = 0; i < jsonData.nodeDataArray.length; i++) {
        let nodeData = jsonData.nodeDataArray[i];
        if (nodeData.elementName && nodeData.elementName !== "") {
        let elementNmae = nodeData.nodeName;
        let elementPhysicalMethod = nodeData.physical_method;
        let elementPhase = nodeData.phase;
        let elementMode = nodeData.mode;
        let elementKey = nodeData.key;
        let elementIsRun = nodeData.isRun??false;
        let elementSection = nodeData.group ? nodeData.group : "";
        let elemnetInputStreams = [];
        let elemnetOutputStreams = [];

        // if(elementNmae==="S-15")
        // {
        //     debugger
        // }

        if (!selectedElements.includes(elementNmae)) continue;

        if (elementSection !== "") {
            if (groupsMap[elementSection]) {
            elementSection = groupsMap[elementSection];
            }
        }

        let elementType = nodeData.elementName;
        if (typeMap2[elementType]) {
            elementType = typeMap2[elementType];
        }

        if (elementType != undefined) {
            if (inputStreamsMap[elementKey]) {
                for (let j = 0; j < inputStreamsMap[elementKey].length; j++) {
                    let streamsName = inputStreamsMap[elementKey][j].name;
                    let streamsRule = inputStreamsMap[elementKey][j].rule;
                    let streamAttribute = inputStreamsMap[elementKey][j].streamAttribute;

                    if (nodeData.type === "DistilStrict" || nodeData.type === "Flash2") {
                    if (streamsRule.length > 0) {
                        if (streamsRule[0] === "T") streamsRule = "D";
                        else if (streamsRule[0] === "B") streamsRule = "B";
                        else streamsRule = "M";
                    } else {
                        streamsRule = "M";
                    }
                    } else {
                    streamsRule = "M";
                    }
                    elemnetInputStreams.push({ name: streamsName, rule: streamsRule ,streamAttribute:streamAttribute });
                }
            }

            if (outputStreamsMap[elementKey]) {
                for (let j = 0; j < outputStreamsMap[elementKey].length; j++) {
                    let streamsName = outputStreamsMap[elementKey][j].name;
                    let streamsRule = outputStreamsMap[elementKey][j].rule;
                    let streamAttribute = outputStreamsMap[elementKey][j].streamAttribute;

                    if (nodeData.type === "DistilStrict" || nodeData.type === "Flash2") {
                    if (streamsRule.length > 0) {
                        if (streamsRule[0] === "T") streamsRule = "D";
                        else if (streamsRule[0] === "B") streamsRule = "B";
                        else streamsRule = "M";
                    } else {
                        streamsRule = "M";
                    }
                    } else {
                    streamsRule = "M";
                    }
                    elemnetOutputStreams.push({ name: streamsName, rule: streamsRule ,streamAttribute:streamAttribute });
                }
            }

            //elemnetInputStreams重新排序
            //特殊处理
            if(elementType==="MultiStreamExchanger" && nodeData.elementName==="换热器4" && elemnetInputStreams.length>0 && elemnetOutputStreams.length>0)
            {
                // console.log("elemnetInputStreams",elemnetInputStreams);
                // console.log("elemnetOutputStreams",elemnetOutputStreams);
                // console.log("nodeData",nodeData);

                if(nodeData.ParamValues["出入流股关系"])
                {
                    if(nodeData.ParamValues["出入流股关系"].p_children)
                    {
                        for(let j=0;j<nodeData.ParamValues["出入流股关系"].p_children.length;j++)
                        {
                            let outStreamName = nodeData.ParamValues["出入流股关系"].p_children[j]["出口流股"].value;
                            let inStreamName = nodeData.ParamValues["出入流股关系"].p_children[j]["入口流股"].value;
                            if(inStreamName && inStreamName!=="")
                            {
                                //获取该出口流股在elemnetOutputStreams中的位置
                                let outStreamIndex = elemnetOutputStreams.findIndex(item => item.name === outStreamName); //如果重名，findIndex方法仅返回第一个的位置
                                let inStreamIndex = elemnetInputStreams.findIndex(item => item.name === inStreamName);
                                if(outStreamIndex!==-1 && inStreamIndex!==-1)
                                {
                                    elemnetInputStreams[inStreamIndex].newIndex = outStreamIndex;
                                }
                            }
                        }

                        //判断是否存在序号重复的情况，若重复则不触发重新排序
                        let indexes = elemnetInputStreams.filter(item => item.newIndex !== undefined).map(item => item.newIndex);
                        if(!(indexes.length !== new Set(indexes).size))
                        {
                            let elemnetInputStreamsLength = elemnetInputStreams.length;
                            let newElemnetInputStreams = new Array(elemnetInputStreamsLength).fill(null); //用null占位
                            let noIndexItems = [];

                            for(let j=0;j<elemnetInputStreams.length;j++)
                            {
                                let elemnetInputStream = elemnetInputStreams[j];
                                if(elemnetInputStream.newIndex)
                                {
                                    newElemnetInputStreams[elemnetInputStream.newIndex] = elemnetInputStream; 
                                }
                                else
                                {
                                    noIndexItems.push(elemnetInputStream)
                                }
                            }

                            //填充空位
                            let noIndexItemsIndex = 0;
                            for (let j=0;j<elemnetInputStreamsLength;j++) 
                            {
                                if (newElemnetInputStreams[j]===null) 
                                {
                                    newElemnetInputStreams[j] = noIndexItems[noIndexItemsIndex++];
                                }
                            }
                            
                            elemnetInputStreams = newElemnetInputStreams;
                            elemnetInputStreams.forEach(item => { delete item.newIndex; });
                        }
                    }
                }
            }

            let elementParams = {};
            let desElementParams = {};
            if (nodeData.ParamValues) {
            for (let key in nodeData.ParamValues) {
                let field = key;
                if (nodeData.ParamValues[key].engName && nodeData.ParamValues[key].engName !== "") {
                field = nodeData.ParamValues[key].engName;
                } else {
                if (fieldMap2[key] !== undefined) field = fieldMap2[key];
                }

                if (nodeData.ParamValues[key].p_children) 
                {
                let children = [];
                let desChildren = [];
                for (let j = 0; j < nodeData.ParamValues[key].p_children.length; j++) {
                    let childrenData = nodeData.ParamValues[key].p_children[j];
                    let childrenParams = {};
                    let desChildrenParams = {};
                    for (let childrenKey in childrenData) {
                    let childrenfield = childrenKey;
                    if (
                        childrenData[childrenKey].engName &&
                        childrenData[childrenKey].engName !== ""
                    ) {
                        childrenfield = childrenData[childrenKey].engName;
                    } else {
                        if (fieldMap2[childrenKey] != undefined) childrenfield = fieldMap2[childrenKey];
                    }

                    if (childrenData[childrenKey].unit) 
                    {
                        let childrenValue = childrenData[childrenKey].value;
                        let desChildrenValue = childrenData[childrenKey].desValue;
                        let childrenEngName = childrenData[childrenKey].engName;

                        if (dataTypeMap[childrenEngName] && dataTypeMap[childrenEngName] === "number") {
                        if (childrenValue !== "") {
                            childrenValue = Number(childrenValue);
                            if (Number.isNaN(childrenValue)) childrenValue = null;
                        } else {
                            childrenValue = null;
                        }

                        if (desChildrenValue !== "") {
                            desChildrenValue = Number(desChildrenValue);
                            if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                        } else {
                            desChildrenValue = null;
                        }
                        } else if (
                        dataTypeMap[childrenEngName] &&
                        dataTypeMap[childrenEngName] === "string"
                        ) {
                        if (childrenValue === "") childrenValue = null;
                        if (desChildrenValue === "") desChildrenValue = null;
                        }

                        childrenParams[childrenfield] = childrenValue;
                        desChildrenParams[childrenfield] = desChildrenValue;
                    } 
                    else 
                    {
                        let childrenValue = childrenData[childrenKey].value;
                        let desChildrenValue = childrenData[childrenKey].desValue;
                        let childrenEngName = childrenData[childrenKey].engName;

                        if (dataTypeMap[childrenEngName] && dataTypeMap[childrenEngName] === "number") {
                        if (childrenValue !== "") {
                            childrenValue = Number(childrenValue);
                            if (Number.isNaN(childrenValue)) childrenValue = null;
                        } else {
                            childrenValue = null;
                        }

                        if (desChildrenValue !== "") {
                            desChildrenValue = Number(desChildrenValue);
                            if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                        } else {
                            desChildrenValue = null;
                        }
                        } else if (
                        dataTypeMap[childrenEngName] &&
                        dataTypeMap[childrenEngName] === "string"
                        ) {
                        if (childrenValue === "") childrenValue = null;
                        if (desChildrenValue === "") desChildrenValue = null;
                        }

                        childrenParams[childrenfield] = childrenValue;
                        desChildrenParams[childrenfield] = desChildrenValue;
                    }
                    }
                    children.push(childrenParams);

                    desChildren.push(desChildrenParams);
                }

                // 特殊处理 DistilStrict 的 Ns/No
                if (nodeData.type === "DistilStrict" && (field === "Ns" || field === "No")) {
                    children = [];
                    desChildren = [];
                    if (field === "Ns") {
                    for (let j = 0; j < elemnetInputStreams.length; j++) {
                        let childrenValue = null;
                        let desChildrenValue = null;
                        let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                        (item: any) => item["流股"]?.value === elemnetInputStreams[j].name,
                        );
                        if (childrenDatas.length > 0) {
                        childrenValue = childrenDatas[0]["进料位置"]?.value;
                        childrenValue = Number(childrenValue);
                        if (Number.isNaN(childrenValue)) childrenValue = null;

                        desChildrenValue = childrenDatas[0]["进料位置"]?.desValue;
                        desChildrenValue = Number(desChildrenValue);
                        if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                        }
                        children.push(childrenValue);
                        desChildren.push(desChildrenValue);
                    }
                    } else if (field === "No") {
                    for (let j = 0; j < elemnetOutputStreams.length; j++) {
                        let childrenValue = null;
                        let desChildrenValue = null;
                        let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                        (item: any) => item["流股"]?.value === elemnetOutputStreams[j].name,
                        );
                        if (childrenDatas.length > 0) {
                        childrenValue = childrenDatas[0]["出料位置"]?.value;
                        childrenValue = Number(childrenValue);
                        if (Number.isNaN(childrenValue)) childrenValue = null;

                        desChildrenValue = childrenDatas[0]["出料位置"]?.desValue;
                        desChildrenValue = Number(desChildrenValue);
                        if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                        }
                        children.push(childrenValue);
                        desChildren.push(desChildrenValue);
                    }
                    }
                }
                if (nodeData.type === "Splitter" && field === "output_f") {
                    children = [];
                    desChildren = [];
                    for (let j = 0; j < elemnetOutputStreams.length; j++) {
                    let childrenValue = null;
                    let desChildrenValue = null;
                    let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                        (item: any) => item["流股"]?.value === elemnetOutputStreams[j].name,
                    );
                    if (childrenDatas.length > 0) {
                        childrenValue = childrenDatas[0]["输出流量"]?.value;

                        if(childrenValue === null || childrenValue === undefined || childrenValue==="")
                        {
                            childrenValue = null;
                        }
                        else 
                        {
                            childrenValue = Number(childrenValue);
                            if (Number.isNaN(childrenValue)) childrenValue = null;
                        }

                        desChildrenValue = childrenDatas[0]["输出流量"]?.desValue;
                        desChildrenValue = Number(desChildrenValue);
                        if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                    }
                    children.push(childrenValue);
                    desChildren.push(desChildrenValue);
                    }
                }
                if (nodeData.type === "DistilStrict" && field === "eff") {
                    // console.log('clssssssssssssssss',children);
                    //字符串改数字
                    children = children.map((obj) =>
                    Object.fromEntries(
                        Object.entries(obj).map(([k, v]) => [k, isNaN(Number(v)) ? null : Number(v)]),
                    ),
                    );
                    desChildren = desChildren.map((obj) =>
                    Object.fromEntries(
                        Object.entries(obj).map(([k, v]) => [k, isNaN(Number(v)) ? null : Number(v)]),
                    ),
                    );

                    for (let j = 0; j < children.length; j++) {
                    let specChildren = [];
                    let desSpecChildren = [];
                    if (
                        nodeData.ParamValues[key].p_children[j]["特殊效率"] 
                        //&& nodeData.ParamValues[key].p_children[j]["特殊效率"].show
                    ) {
                        for (
                        let k = 0;
                        k < nodeData.ParamValues[key].p_children[j]["特殊效率"].children.length;
                        k++
                        ) {
                            // console.log('nodeData.ParamValues[key].p_children[j]["特殊效率"].children',nodeData.ParamValues[key].p_children[j]["特殊效率"].children);
                        let specValue = nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["效率值"].value;
                        const zfname=nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["组分"].value
                        let specIdx = state.curFlow.global_data.materials.findIndex((g)=>g.name===zfname) + 1
                        
                        // nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["组分"].value;
                        //     state.curFlow.global_data.materials

                        if(specValue===""||specValue === null)
                        {
                            specValue = null;
                        }
                        else 
                        {
                            specValue = Number(specValue);
                            if (Number.isNaN(specValue)) specValue = null;

                        }
                        if(specValue!==null)
                        {
                            // let specChild = [k + 1,specValue];
                            let specChild = [specIdx,specValue];
                            specChildren.push(specChild);
                        }
                        let desSpecValue =
                            nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["效率值"]
                            .desValue;
                        let desSpecChild = [
                            // k + 1,
                            specIdx,
                            isNaN(Number(desSpecValue)) ? null : Number(desSpecValue),
                        ];
                        desSpecChildren.push(desSpecChild);
                        }
                    }

                    //判断若spec的每个值都为0，则为空数组
                    if(specChildren.every((item) => item[1] === 0))
                    {
                        specChildren = [];
                        desSpecChildren = [];
                    }

                    children[j].spec = specChildren;
                    desChildren[j].spec = desSpecChildren;
                    }
                }
                if (
                    nodeData.type === "MultiStreamExchanger" &&
                    (field === "cold_out_T" ||
                    field === "hot_out_T" ||
                    field === "cold_out_P" ||
                    field === "hot_out_P")  //换热器4
                )
                {
                    let streamType = [];
                    let unitField = MultiStreamExchanger.find((item) => item.nodeName === nodeData.elementName).params.find((item) => item.p_engName === field).p_children.find((item) => item["p_unitField"])["p_unitField"];
                    let type = MultiStreamExchanger.find((item) => item.nodeName === nodeData.elementName).params.find((item) => item.p_engName === field).p_children.find((item) => item["p_type"])["p_type"];

                    let newChildren = [];
                    
                    let runField = null;
                    if(field==="cold_out_T"||field==="hot_out_T")
                    {
                        runField = "out_T";
                    }
                    else if(field==="cold_out_P"||field==="hot_out_P")
                    {
                        runField = "out_P";
                    }

                    let Ttype = null;   //当前字段温度类型，cold或hot
                    if(field.includes("cold"))
                    {
                        Ttype = "cold";
                    }
                    else
                    {
                        Ttype = "hot";
                    }

                    if(elementParams[runField])
                    {
                        continue;
                    }

                    let coldChildren = [];
                    let hotChildren = [];

                    if(Ttype==="cold")
                    {
                        coldChildren = children;
                        hotChildren = nodeData.ParamValues[`热流股${runField==="out_T"?"出口温度":(runField==="out_P"?"出口压力":"")}`].p_children;

                        let newHotChildren = [];
                        for (let j=0;j<hotChildren.length;j++) 
                        {
                            let hotChildrenData = hotChildren[j];
                            let newHotChildrenData = {};
                            for (let hotChildrenKey in hotChildrenData) 
                            {
                                let hotChildrenEngName = hotChildrenData[hotChildrenKey].engName;
                                let hotChildrenValue = hotChildrenData[hotChildrenKey].value;
                                newHotChildrenData[hotChildrenEngName] = hotChildrenValue;
                            }
                            newHotChildren.push(newHotChildrenData);
                        }
                        hotChildren = newHotChildren;
                    }
                    else if(Ttype==="hot")
                    {
                        hotChildren = children;
                        coldChildren = nodeData.ParamValues[`冷流股${runField==="out_T"?"出口温度":(runField==="out_P"?"出口压力":"")}`].p_children;
                    
                        let newColdChildren = [];
                        for (let j=0;j<coldChildren.length;j++) 
                        {
                            let coldChildrenData = coldChildren[j];
                            let newColdChildrenData = {};
                            for (let coldChildrenKey in coldChildrenData) 
                            {
                                let coldChildrenEngName = coldChildrenData[coldChildrenKey].engName;
                                let coldChildrenValue = coldChildrenData[coldChildrenKey].value;
                                newColdChildrenData[coldChildrenEngName] = coldChildrenValue;
                            }
                            newColdChildren.push(newColdChildrenData);
                        }
                        coldChildren = newColdChildren;
                    }

                    for (let j = 0; j < elemnetOutputStreams.length; j++)
                    {
                        let streamAttribute = elemnetOutputStreams[j].streamAttribute;
                        let child = null;
                        if(streamAttribute==="冷流股")
                        {
                            child = coldChildren.find((item) => item.streamName === elemnetOutputStreams[j].name);
                        }
                        else if(streamAttribute==="热流股")
                        {
                            child = hotChildren.find((item) => item.streamName === elemnetOutputStreams[j].name);
                        }

                        if(child)
                        {
                            let childValue = child[runField==="out_T"?"出口温度":(runField==="out_P"?"出口压力":"")];
                            if (childValue !== "")
                            {
                                childValue = Number(childValue);
                                if (Number.isNaN(childValue)) childValue = null;
                            } 
                            else 
                            {
                                childValue = null;
                            }

                            streamType.push(streamAttribute==="冷流股"?"cold":(streamAttribute==="热流股"?"hot":null));
                            newChildren.push(childValue);
                        }
                    }

                    elementParams["stream_type"] = streamType;
                    let unitFieldValue = null;

                    if(nodeData.ParamValues[key].p_children)
                    {
                        for(let k=0;k<nodeData.ParamValues[key].p_children.length;k++)
                        {
                            if(nodeData.ParamValues[key].p_children[k][field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"])
                            {
                                unitFieldValue = nodeData.ParamValues[key].p_children[k][field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"].unit;
                            }
                        }
                    }
                    if(unitFieldValue)
                    {
                        elementParams[unitField] = unitFieldValue;
                        desElementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                    }
                    else
                    {
                        if(!elementParams[unitField])
                        {
                            //给个默认值
                            elementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                            desElementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                        }
                    }
                    desElementParams["stream_type"] = streamType;
                    children = newChildren;
                    desChildren = newChildren;

                    elementParams[runField] = children;
                    elementParams[`cold_${runField}`] = children;
                    elementParams[`hot_${runField}`] = children;

                    desElementParams[runField] = desChildren;
                    desElementParams[`cold_${runField}`] = desChildren;
                    desElementParams[`hot_${runField}`] = desChildren;
                    continue;
                }
                // {
                //     let streamType = [];
                //     let unitField = MultiStreamExchanger
                //     .find((item) => item.nodeName === nodeData.elementName)
                //     .params.find((item) => item.p_engName === field)
                //     .p_children.find((item) => item["p_unitField"])["p_unitField"];
                //     let type = MultiStreamExchanger
                //     .find((item) => item.nodeName === nodeData.elementName)
                //     .params.find((item) => item.p_engName === field)
                //     .p_children.find((item) => item["p_type"])["p_type"];
                //     if (nodeData.ParamValues["流股属性"]) {
                //     let streamAttribute = nodeData.ParamValues["流股属性"].value;
                //     if (streamAttribute === "冷流股") {
                //         if (field === "hot_out_T" || field === "hot_out_P") {
                //         continue;
                //         }
                //     } else if (streamAttribute === "热流股") {
                //         if (field === "cold_out_T" || field === "cold_out_P") {
                //         continue;
                //         }
                //     } else {
                //         if (field === "cold_out_T" || field === "hot_out_T") {
                //         field = "out_T";
                //         } else if (field === "cold_out_P" || field === "hot_out_P") {
                //         field = "out_P";
                //         }
                //         children = [];
                //         desChildren = [];
                //         elementParams[field] = children;
                //         elementParams["stream_type"] = streamType;
                //         elementParams[unitField] = unitMap[type]?.[0];

                //         desElementParams[field] = desChildren;
                //         desElementParams["stream_type"] = streamType;
                //         desElementParams[unitField] = unitMap[type]?.[0];
                //         continue;
                //     }
                //     let newChildren = [];
                //     let desNewChildren = [];
                //     for (let j = 0; j < elemnetOutputStreams.length; j++) {
                //         let child = children.find(
                //         (item) => item.streamName === elemnetOutputStreams[j].name,
                //         );
                //         let desChild = desChildren.find(
                //         (item) => item.streamName === elemnetOutputStreams[j].name,
                //         );
                //         if (child) {
                //         let childValue =
                //             child[
                //             field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"
                //             ];
                //         if (childValue !== "") {
                //             childValue = Number(childValue);
                //             if (Number.isNaN(childValue)) childValue = null;
                //         } else {
                //             childValue = null;
                //         }

                //         streamType.push(streamAttribute === "冷流股" ? "cold" : "hot");
                //         newChildren.push(childValue);

                //         if (desChild) {
                //             let desChildValue =
                //             desChild[
                //                 field === "cold_out_T" || field === "hot_out_T"
                //                 ? "出口温度"
                //                 : "出口压力"
                //             ];
                //             if (desChildValue !== "") {
                //             desChildValue = Number(desChildValue);
                //             if (Number.isNaN(desChildValue)) desChildValue = null;
                //             } else {
                //             desChildValue = null;
                //             }

                //             desNewChildren.push(desChildValue);
                //         }
                //         } else {
                //         //判断该流股属性是否为"无"
                //         let link = jsonData.linkDataArray.find(
                //             (item:any) => item.linkName === elemnetOutputStreams[j].name,
                //         );
                //         if (
                //             link.ParamValues["流股属性"] &&
                //             link.ParamValues["流股属性"].value !== "无"
                //         ) {
                //             let childValue = null;
                //             streamType.push(streamAttribute === "冷流股" ? "hot" : "cold");
                //             newChildren.push(childValue);

                //             let desChildValue = null;
                //             desNewChildren.push(desChildValue);
                //         }
                //         }
                //     }
                //     elementParams["stream_type"] = streamType;
                //     let unitFieldValue = null;
                //     if(nodeData.ParamValues[key].p_children)
                //     {
                //         for(let k=0;k<nodeData.ParamValues[key].p_children.length;k++)
                //         {
                //             if(nodeData.ParamValues[key].p_children[k][field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"])
                //             {
                //                 unitFieldValue = nodeData.ParamValues[key].p_children[k][field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"].unit;
                //             }
                //         }
                //     }
                //     if(unitFieldValue)
                //     {
                //         elementParams[unitField] = unitFieldValue;
                //         desElementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                //     }
                //     else
                //     {
                //         if(!elementParams[unitField])
                //         {
                //             //给个默认值
                //             elementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                //             desElementParams[unitField] = (field === "cold_out_T" || field === "hot_out_T")?"C":"MPa";
                //         }
                //     }
                //     desElementParams["stream_type"] = streamType;
                //     children = newChildren;
                //     desChildren = desNewChildren;
                //     } else {
                //     if (field === "cold_out_T" || field === "hot_out_T") {
                //         field = "out_T";
                //     } else if (field === "cold_out_P" || field === "hot_out_P") {
                //         field = "out_P";
                //     }
                //     children = [];
                //     desChildren = [];
                //     elementParams["stream_type"] = streamType;
                //     elementParams[unitField] = unitMap[type]?.[0];

                //     desElementParams["stream_type"] = streamType;
                //     desElementParams[unitField] = unitMap[type]?.[0];
                //     }
                // }
                if (nodeData.type === "ShellAndTubeExchanger" && field === "stream_type") 
                {
                    children = children[0];
                    desChildren = desChildren[0];

                    //初值给null
                    children["stream_in_cold"] = null;
                    children["stream_in_hot"] = null;
                    children["stream_out_cold"] = null;
                    children["stream_out_hot"] = null;
                    desChildren["stream_in_cold"] = null;
                    desChildren["stream_in_hot"] = null;
                    desChildren["stream_out_cold"] = null;
                    desChildren["stream_out_hot"] = null;
                    
                    // //唯一性校验
                    // if(elemnetInputStreams.filter(item=>item.streamAttribute==="冷流股").length>1)
                    // {
                    //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：冷流股入口数量大于1`;
                    //   input["error"] = errorMessage;
                    //   return input;
                    // }
                    // if(elemnetInputStreams.filter(item=>item.streamAttribute==="热流股").length>1)
                    // {
                    //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：热流股入口数量大于1`;
                    //   input["error"] = errorMessage;
                    //   return input;
                    // }
                    // if(elemnetOutputStreams.filter(item=>item.streamAttribute==="冷流股").length>1)
                    // {
                    //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：冷流股出口数量大于1`;
                    //   input["error"] = errorMessage;
                    //   return input;
                    // }
                    // if(elemnetOutputStreams.filter(item=>item.streamAttribute==="热流股").length>1)
                    // {
                    //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：热流股出口数量大于1`;
                    //   input["error"] = errorMessage;
                    //   return input;
                    // }

                    for (let j = 0; j < elemnetInputStreams.length; j++) 
                    {
                    if(elemnetInputStreams[j].streamAttribute==="冷流股")
                    {
                        children["stream_in_cold"] = j+1;
                        desChildren["stream_in_cold"] = j+1;
                    }
                    else if(elemnetInputStreams[j].streamAttribute==="热流股")
                    {
                        children["stream_in_hot"] = j+1;
                        desChildren["stream_in_hot"] = j+1;
                    }
                    }

                    for (let j = 0; j < elemnetOutputStreams.length; j++) 
                    {
                    if(elemnetOutputStreams[j].streamAttribute==="冷流股")
                    {
                        children["stream_out_cold"] = j+1;
                        desChildren["stream_out_cold"] = j+1;
                    }
                    else if(elemnetOutputStreams[j].streamAttribute==="热流股")
                    {
                        children["stream_out_hot"] = j+1;
                        desChildren["stream_out_hot"] = j+1;
                    }
                    }

                    Object.keys(children).forEach(key => 
                    {
                    if (!children[key]) 
                    {
                        delete children[key];
                    }
                    });
                    Object.keys(desChildren).forEach(key => 
                    {
                    if (!desChildren[key]) 
                    {
                        delete desChildren[key];
                    }
                    });
                }

                    elementParams[field] = children;
                    desElementParams[field] = desChildren;
                } 
                else 
                {
                    if (nodeData.ParamValues[key].unit) 
                    {
                        let value = nodeData.ParamValues[key].value;
                        let desValue = nodeData.ParamValues[key].desValue;
                        let engName = nodeData.ParamValues[key].engName;

                        if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                        if (value !== "" && value != null) {
                            value = Number(value);
                            if (Number.isNaN(value)) value = null;
                        } else {
                            value = null;
                        }

                        if (desValue !== "" && desValue != null) {
                            desValue = Number(desValue);
                            if (Number.isNaN(desValue)) desValue = null;
                        } else {
                            desValue = null;
                        }
                        } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                        if (value === "") value = null;
                        if (desValue === "") desValue = null;
                        }

                        //特殊处理
                        if (nodeData.type === "Flash2" && (field === "t" || field === "vaporFraction")) 
                        {
                            if (elementMode === "TP") 
                            {
                                if (field === "vaporFraction") 
                                {
                                    continue;
                                }
                            } 
                            else if (elementMode === "VP" || elementMode === "HP") 
                            {
                                if (field === "t") 
                                {
                                    continue;
                                }
                            } 
                            else 
                            {
                                continue;
                            }
                        }
                        if (
                            nodeData.type === "ShellAndTubeExchanger" &&
                            (field === "cold_out_T" ||
                            field === "hot_out_T" ||
                            field === "cold_out_P" ||
                            field === "hot_out_P")  //非换热器4
                        )
                        {
                            if (nodeData.ParamValues["流股属性"]) 
                            {
                                let streamAttribute = nodeData.ParamValues["流股属性"].value;
                                if (streamAttribute === "冷流股") 
                                {
                                    if (field === "hot_out_T" || field === "hot_out_P") 
                                    {
                                        value = null;
                                        desValue = null;
                                    }
                                } 
                                else if (streamAttribute === "热流股") 
                                {
                                    if (field === "cold_out_T" || field === "cold_out_P") 
                                    {
                                        value = null;
                                        desValue = null;
                                    }
                                }
                                else
                                {
                                    value = null;
                                    desValue = null;
                                }
                            }
                            else
                            {
                                value = null;
                                desValue = null;
                            }
                        }

                        elementParams[field] = value;
                        desElementParams[field] = desValue;

                        if (nodeData.ParamValues[key].unitField !== undefined) {
                        if (nodeData.ParamValues[key].unitField !== null) {
                            if (nodeData.ParamValues[key].unitField === "") {
                            elementParams[`${field}_unit`] = nodeData.ParamValues[key].unit;
                            desElementParams[`${field}_unit`] = nodeData.ParamValues[key].unit;
                            } else {
                            elementParams[nodeData.ParamValues[key].unitField] =
                                nodeData.ParamValues[key].unit;
                            desElementParams[nodeData.ParamValues[key].unitField] =
                                nodeData.ParamValues[key].unit;
                            }
                        }
                        }
                    } 
                    else 
                    {
                        let value = nodeData.ParamValues[key].value;
                        let desValue = nodeData.ParamValues[key].desValue;
                        let engName = nodeData.ParamValues[key].engName;

                        if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                        if (value !== "" && value != null) {
                            value = Number(value);
                            if (Number.isNaN(value)) value = null;
                        } else {
                            value = null;
                        }

                        if (desValue !== "" && desValue != null) {
                            desValue = Number(desValue);
                            if (Number.isNaN(desValue)) desValue = null;
                        } else {
                            desValue = null;
                        }
                        } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                        if (value === "") value = null;
                        if (desValue === "") desValue = null;
                        }

                        //特殊处理
                        if (nodeData.type === "DistilStrict" && field === "type") 
                        {
                            let elementName = nodeData.elementName;
                            value = towerJson.filter((item: any) => item.nodeName === elementName)?.[0]?.type;
                            desValue = towerJson.filter((item: any) => item.nodeName === elementName)?.[0]
                                ?.type;
                        }
                        if (
                            nodeData.type === "DistilStrict" &&
                            (field === "trayType" || field === "packingType")
                        ) 
                        {
                        if (nodeData.ParamValues["内部类型"]) 
                        {
                            if (nodeData.ParamValues["内部类型"].value === "塔板") 
                            {
                            if (field === "packingType")
                                {
                                    continue;
                                }
                            } 
                            else if (nodeData.ParamValues["内部类型"].value === "填料") 
                            {
                                if (field === "trayType") 
                                {
                                    continue;
                                }
                            } 
                            else if (nodeData.ParamValues["内部类型"].value === "混合") 
                            {
                                //同时存在，不做处理
                            } 
                            else 
                            {
                                continue;
                            }
                        }
                        else 
                        {
                            continue;
                        }
                        }
                        if (nodeData.type === "Flash2" && (field === "t" || field === "vaporFraction")) {
                        if (elementMode === "TP") {
                            if (field === "vaporFraction") {
                            continue;
                            }
                        } else if (elementMode === "VP" || elementMode === "HP") {
                            if (field === "t") {
                            continue;
                            }
                        } else {
                            continue;
                        }
                        }
                        // if (field === "streamAttribute") 
                        // {
                        //     continue;
                        // }

                        elementParams[field] = value;
                        desElementParams[field] = desValue;
                    }
                }
            }
            }

            //特殊处理
            if (nodeData.type === "DistilStrict") 
            {
                elementParams["V_list"] = { NV: [], W: [] };
                elementParams["L_list"] = { NL: [], U: [] };
                elementParams["Q_list"] = { NQ: [], QH: [] };
            }
            // //添加取消前缀的字段
            // if (nodeData.type === "MultiStreamExchanger"||nodeData.elementName === "换热器4")
            // {
            //     if(elementParams["cold_out_P"])
            //     {
            //         elementParams["out_P"] = elementParams["cold_out_P"];
            //     }
            //     if(elementParams["hot_out_P"])
            //     {
            //         elementParams["out_P"] = elementParams["hot_out_P"];
            //     }
            //     if(elementParams["cold_out_T"])
            //     {
            //         elementParams["out_T"] = elementParams["cold_out_T"];
            //     }
            //     if(elementParams["hot_out_T"])
            //     {
            //         elementParams["out_T"] = elementParams["hot_out_T"];
            //     }
            // }

            let element = {
            mode: elementMode,
            name: elementNmae,
            phase: elementPhase,
            physical_method: elementPhysicalMethod,
            section: elementSection,
            type: elementType,
            params: elementParams,
            inputStreams: elemnetInputStreams,
            outputStreams: elemnetOutputStreams,
            isRun:elementIsRun,
            };

            if(type==="run")
            {
                element.isRun = true;
            }
            else if(type==="creat")
            {
                element.isRun = false;
            }

            if(isCopy)
            {
                element.isRun = false;
            }
            // debugger
            // //测试用：run随机改为true
            // if(Math.random()>0.5)
            // {
            //     element.isRun = true;
            // }

            elements.push(element);

            let desElement = {
            mode: elementMode,
            name: elementNmae,
            phase: elementPhase,
            physical_method: elementPhysicalMethod,
            section: elementSection,
            type: elementType,
            params: desElementParams,
            inputStreams: elemnetInputStreams,
            outputStreams: elemnetOutputStreams,
            isRun:elementIsRun,
            };
            desElements.push(desElement);
        }
        }
    }

    let input = 
    {
        flow_id: flowId,
        name: taskName,
        description: flowDes,
        cal:cal,
        // design_input: {
        //   elements: desElements,
        //   streams: setStreamsType(desElements, desStreams, jsonData),
        // },
    };

    if(type==="creat"||type==="run")
    {
        input["mix_input"] = 
        {
            selected_blocks: selectedElements,
            global_physical_method: globlePhysicalMethod,
            elements: elements,
            streams: setStreamsType(elements,streams,jsonData),
        };
    }
    else if(type==="save")
    {
        input["input"] = JSON.stringify(
        {
            selected_blocks: selectedElements,
            global_physical_method: globlePhysicalMethod,
            elements: elements,
            streams: setStreamsType(elements,streams,jsonData),
        });
    }

    // console.log('inputwwerww',elements);
    return input;
};
